import classNames from 'classnames';
import { ExerciseData } from '../../modules/exercises';
import { ExerciseDto } from '../../modules/interfaces';

type Props = {
    exercise: ExerciseDto;
    exerciseData: ExerciseData;
};
export function ExerciseView({ exercise, exerciseData }: Props) {
    return (
        <div className="container-in-app flex grow flex-col px-20">
            {exerciseData.LogbookHeader && (
                <exerciseData.LogbookHeader
                    className="my-20"
                    exercise={exercise}
                />
            )}
            {exerciseData.questions
                .map((x) => {
                    const answers = x.dataKeys
                        .map((x) => exercise.Data[x])
                        .flatMap((answer) =>
                            x.isArray && answer ? JSON.parse(answer) : [answer],
                        )
                        .filter(Boolean);

                    if (answers.length === 0) {
                        return null;
                    }

                    return {
                        ...x,
                        answers,
                    };
                })
                .filter(Boolean)
                .map((x, idx) => (
                    <x.Answers
                        key={idx}
                        answers={x.answers}
                        exercise={exercise}
                        className={classNames({
                            'mt-30': idx !== 0,
                        })}
                    />
                ))}
        </div>
    );
}
